import Anchor from "@p-ban/common/src/components/html/Anchor"
import Image from "@p-ban/common/src/components/html/Image"

import img from "./jpca2018.png"

const JPCA = () => {
  return (
    <Anchor href="https://jpca.jp/" newTab>
      <Image src={img} alt="jpca" />
    </Anchor>
  )
}

export default JPCA
